/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_PerformanceRuleListDto } from '../models/PagedResultDto_PerformanceRuleListDto';
import type { Wealthlane_AwardService_Dtos_Common_DropdownDto } from '../models/Wealthlane_AwardService_Dtos_Common_DropdownDto';
import type { Wealthlane_AwardService_Dtos_Common_IntDropdownDto } from '../models/Wealthlane_AwardService_Dtos_Common_IntDropdownDto';
import type { Wealthlane_AwardService_Dtos_PerformanceRule_AddPerformanceRulesDto } from '../models/Wealthlane_AwardService_Dtos_PerformanceRule_AddPerformanceRulesDto';
import type { Wealthlane_AwardService_Dtos_PerformanceRule_PerformanceRulesByIdDto } from '../models/Wealthlane_AwardService_Dtos_PerformanceRule_PerformanceRulesByIdDto';
import type { Wealthlane_AwardService_Dtos_PerformanceRule_PsuRuleImportSampleDownloadResponse } from '../models/Wealthlane_AwardService_Dtos_PerformanceRule_PsuRuleImportSampleDownloadResponse';
import type { Wealthlane_AwardService_Dtos_PerformanceRule_TogglePerformanceRuleDto } from '../models/Wealthlane_AwardService_Dtos_PerformanceRule_TogglePerformanceRuleDto';
import type { Wealthlane_AwardService_Dtos_PerformanceRule_UpdatePerformanceRulesDto } from '../models/Wealthlane_AwardService_Dtos_PerformanceRule_UpdatePerformanceRulesDto';
import type { Wealthlane_AwardService_Dtos_Response_ResponseDto } from '../models/Wealthlane_AwardService_Dtos_Response_ResponseDto';
import type { Wealthlane_Shared_Hosting_Dtos_GenericResponseDtos_GenericTaskResponseDto } from '../models/Wealthlane_Shared_Hosting_Dtos_GenericResponseDtos_GenericTaskResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class PerformanceRuleService {

    /**
     * @returns Wealthlane_AwardService_Dtos_Common_DropdownDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppPerformanceRulePerformanceRuleTypes(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_Common_DropdownDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/performance-rule/performance-rule-types',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_Common_IntDropdownDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppPerformanceRuleRuleAvailableStatusList(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_Common_IntDropdownDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/performance-rule/rule-available-status-list',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_Common_IntDropdownDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppPerformanceRuleRuleApprovalStatusList(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_Common_IntDropdownDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/performance-rule/rule-approval-status-list',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_Common_IntDropdownDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppPerformanceRuleRuleEarnedlStatusList(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_Common_IntDropdownDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/performance-rule/rule-earnedl-status-list',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_Common_DropdownDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppPerformanceRuleAvailablePerformanceRules(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_Common_DropdownDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/performance-rule/available-performance-rules',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param grantId 
     * @returns Wealthlane_AwardService_Dtos_Common_DropdownDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppPerformanceRuleAvailablePerformanceRulesForGrant(
grantId: string,
): CancelablePromise<Array<Wealthlane_AwardService_Dtos_Common_DropdownDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/performance-rule/available-performance-rules-for-grant/{grantId}',
            path: {
                'grantId': grantId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppPerformanceRulePerformanceRule(
requestBody?: Wealthlane_AwardService_Dtos_PerformanceRule_AddPerformanceRulesDto,
): CancelablePromise<Wealthlane_AwardService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/performance-rule/performance-rule',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static putApiAwardApiAppPerformanceRulePerformanceRule(
requestBody?: Wealthlane_AwardService_Dtos_PerformanceRule_UpdatePerformanceRulesDto,
): CancelablePromise<Wealthlane_AwardService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/award/api/app/performance-rule/performance-rule',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static putApiAwardApiAppPerformanceRulePerformanceRuleAsyncOld(
requestBody?: Wealthlane_AwardService_Dtos_PerformanceRule_UpdatePerformanceRulesDto,
): CancelablePromise<Wealthlane_AwardService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/award/api/app/performance-rule/performance-rule-async-old',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @returns Wealthlane_AwardService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static deleteApiAwardApiAppPerformanceRulePerformanceRule(
id: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/award/api/app/performance-rule/{id}/performance-rule',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppPerformanceRuleTogglePerformanceRuleAvailableStatus(
requestBody?: Wealthlane_AwardService_Dtos_PerformanceRule_TogglePerformanceRuleDto,
): CancelablePromise<Wealthlane_AwardService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/performance-rule/toggle-performance-rule-available-status',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @returns Wealthlane_AwardService_Dtos_PerformanceRule_PerformanceRulesByIdDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppPerformanceRulePerformanceRulesById(
id: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_PerformanceRule_PerformanceRulesByIdDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/performance-rule/{id}/performance-rules-by-id',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param evaluationPeriodFrom 
     * @param evaluationPeriodTo 
     * @param approvalStatus 
     * @param ruleStatus 
     * @param earnedStatus 
     * @param filter 
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns PagedResultDto_PerformanceRuleListDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppPerformanceRulePerformanceRuleList(
evaluationPeriodFrom?: string,
evaluationPeriodTo?: string,
approvalStatus?: Array<number>,
ruleStatus?: number,
earnedStatus?: number,
filter?: string,
sorting?: string,
skipCount?: number,
maxResultCount?: number,
): CancelablePromise<PagedResultDto_PerformanceRuleListDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/performance-rule/performance-rule-list',
            query: {
                'EvaluationPeriodFrom': evaluationPeriodFrom,
                'EvaluationPeriodTo': evaluationPeriodTo,
                'ApprovalStatus': approvalStatus,
                'RuleStatus': ruleStatus,
                'EarnedStatus': earnedStatus,
                'Filter': filter,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param formData 
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericResponseDtos_GenericTaskResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppPerformanceRuleImportPerformanceRule(
formData?: {
File?: Blob;
},
): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericResponseDtos_GenericTaskResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/performance-rule/import-performance-rule',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_PerformanceRule_PsuRuleImportSampleDownloadResponse OK
     * @throws ApiError
     */
    public static postApiAwardApiAppPerformanceRuleDownloadPerformanceRuleTemplate(): CancelablePromise<Wealthlane_AwardService_Dtos_PerformanceRule_PsuRuleImportSampleDownloadResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/performance-rule/download-performance-rule-template',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
